import { BulletList, Bullet } from 'components/BulletList';
import CenterAlignBox from 'components/Containers/CenterAlignBox';
import ColumnBox from 'components/Containers/ColumnBox';
import { Row } from 'components/Containers/Row/Row';
import SpreadBox from 'components/Containers/SpreadBox';
import OText from 'components/CText/OText';
import DisclaimerPortal from 'components/Disclaimer/DisclaimerPortal';
import { Image } from 'components/Image/Image';
import DirectDepositInfoField from 'pages/Cash/pages/DirectDepositInformation/components/DirectDepositInfoField';
import React from 'react';
import { SectionContainer } from 'components/Containers/SectionContainer/SectionContainer';
import Label from 'components/form/Label/Label';

const DirectDepositManualView = props => {
  return (
    <>
      {props.seenPixel}
      <SectionContainer datatestid="direct-deposit-manual-module">
        <Row>
          <SpreadBox>
            <ColumnBox widthClassName="format48 m-format100">
              <CenterAlignBox className="d-hide padB24">
                <Image imgClass={props.hero} />
              </CenterAlignBox>
              <Label type="H3 mH5 bold" className="padB16">
                <OText text={props.title} />
              </Label>

              <Label type="Body-1" className="padB32 m-padB24">
                <OText text={props.content} />
              </Label>

              <BulletList paddingLeftClass="padL0" className=" margB0">
                {props.bullets?.map((b, x) => (
                  <Bullet
                    key={x}
                    textClass="padL8 Body-1"
                    bulletCharacter={
                      <Label className="text-24">{b.icon}</Label>
                    }
                  >
                    {b.text}
                  </Bullet>
                ))}
              </BulletList>
            </ColumnBox>
            <ColumnBox
              widthClassName="format50"
              className=" t-hide"
              alignItemsEnd
            >
              <Image imgClass={props.hero} />
            </ColumnBox>
          </SpreadBox>
        </Row>
        <Row>
          <DirectDepositInfoField
            title="Customer name"
            value={props.customerName}
            onClickCopy={props.onClickCopyField}
            className="borderTp borderBottom borderColorGray025"
            datatestid="name"
          />
          <DirectDepositInfoField
            title="Routing number"
            value={props.routingNumber}
            onClickCopy={props.onClickCopyField}
            className="borderBottom borderColorGray025"
            datatestid="routing-number"
          />
          <DirectDepositInfoField
            title="Account number"
            value={props.accountNumber}
            onClickCopy={props.onClickCopyField}
            className="borderBottom borderColorGray025"
            datatestid="account-number"
          />
        </Row>
        <DisclaimerPortal name="DD_man">
          <OText text={props.disclaimers} />
        </DisclaimerPortal>
      </SectionContainer>
    </>
  );
};

export default DirectDepositManualView;
